import React, { Fragment } from 'react'
import { translate } from '../Services/translation'

const TopLinks = ({
    links,
    iconCssClass,
    menuLinkTitle,
    showOnlyTextIfSingleLink,
    currentLanguage,
    showTopLinks,
    toggleShowTopLinks,
}) => {
    return (
        <Fragment>
            {links && links.length > 0 && (
                <Fragment>
                    {links.length > 1 ? (
                        <Fragment>
                            <a
                                className="top-link__link--block"
                                href="#!"
                                onClick={() => toggleShowTopLinks()}
                                title={translate(menuLinkTitle)}
                            >
                                <div
                                    className={`top-link__text${
                                        showTopLinks ? '--bold' : ''
                                    }`}
                                >
                                    {currentLanguage}
                                </div>
                                <span className="top-link__title--hidden">
                                    {translate('toplinks.title')}
                                </span>
                                <div
                                    className={`top-link__icon ${
                                        showTopLinks
                                            ? 'top-link__icon--rotate'
                                            : ''
                                    }`}
                                >
                                    <i className={iconCssClass} />
                                </div>
                            </a>

                            <div
                                className={`top-link__links ${
                                    !showTopLinks
                                        ? 'top-link__links--hidden'
                                        : ''
                                }`}
                            >
                                {links.map((link, index) => (
                                    <div key={index} className="top-link__item">
                                        <a
                                            className="top-link__link"
                                            href={link.href}
                                        >
                                            <span className="top-link__item-title">
                                                {link.text}
                                            </span>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </Fragment>
                    ) : showOnlyTextIfSingleLink ? (
                        <a
                            className="top-link__link--block"
                            href={links[0].href}
                        >
                            <span className="top-link__title">
                                {links[0].text}
                            </span>
                        </a>
                    ) : (
                        <a
                            className="top-link__link--block"
                            href={links[0].href}
                            title={links[0].text}
                        >
                            {links[0].text}
                            <span className="top-link__title--hidden">
                                {links[0].text}
                            </span>
                        </a>
                    )}
                </Fragment>
            )}
        </Fragment>
    )
}

export default TopLinks
